<template>
  <div class="adminWebsiteConfig">
     <div
      class="d-flex flex-row justify-content-between align-items-center align-self-start"
    >
      <div class="form-div mr-3" style="width: 50%">
        <label class="m-0">Website title</label>
        <div class="input-div">
          <b-form-input
            :placeholder="'Website title'"
            v-model="title"
            class="input-search"
          ></b-form-input>
        </div>
      </div>
    </div>
    <b-form-checkbox v-model="checked" name="check-button" switch class="mb-2">
            <b>{{ $t("adminDashboard.navigation.WebsiteSsettings") }}</b>
        </b-form-checkbox>
    <div class="d-flex flex-row justify-content-between align-items-center align-self-start">
      
      <div class="form-div d-flex flex-column justify-content-between align-items-start align-items-stretch" style="width: 50%">
        
        <div class="d-flex flex-row justify-content-between">
          <label class="m-0">{{ $t("adminDashboard.navigation.WebsiteSsettings") }}</label>
        </div>
        <div class="input-div">
          <b-textarea  id="textarea"
             :placeholder="'Website subtitle'"
              v-model="webSiteSubtitle"
              class="input-search"
            :disabled="!checked"
              rows="4"
              max-rows="6" style="overflow: hidden;"></b-textarea>
         
        </div>
      </div>
      <div class="form-div ml-3 d-flex flex-column justify-content-between align-items-start align-items-stretch" style="width: 50%">
        <div class="d-flex flex-row justify-content-between">
          <label class="m-0">Meta Keywords</label>
        </div>
        
        <div class="input-div">
          <b-form-tags
            input-id="tags-validation"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            separator=" ,;"
            remove-on-delete
            :tag-validator="tagValidator"
            v-model="meta_keywords"
            
            tag-pills
            size="md"
            :placeholder="'Meta Keywords'"
            isDuplicate="false"
          ></b-form-tags>
        </div>
      </div>
    </div>
    <div
      class="d-flex flex-row justify-content-between align-items-center align-self-start"
    >
      
      <div class="form-div d-flex flex-column justify-content-between align-items-start align-items-stretch" style="width: 50%">
        <div class="d-flex flex-row justify-content-between">
          <label class="m-0">Meta Description</label>
        </div>
        <div class="input-div">
          <b-textarea  id="textarea"
             :placeholder="'Meta Description'"
              v-model="meta_description"
              class="input-search"
              rows="4"
              max-rows="6" style="overflow: hidden;"></b-textarea>
          
        </div>
      </div>
      <div class="form-div ml-3 d-flex flex-column justify-content-between align-items-start align-items-stretch" style="width: 50%">
        <label>Meta Image Url</label>
        <div class="input-div">
          <b-textarea  id="textarea"
             :placeholder="'Meta Image Url'"
              v-model="meta_image"
              class="input-search"
              rows="4"
              max-rows="6" style="overflow: hidden;"></b-textarea>
        </div>
      </div>
    </div>

<div
      class="d-flex flex-row justify-content-between align-items-center align-self-start"
    >
      <div class="form-div" style="width: 50%">
        <label>Affiliate Title</label>
        <div class="input-div">
          <b-form-input
            :placeholder="'Affiliate'"
            v-model="affiliate"
            class="input-search"
          ></b-form-input>
        </div>
      </div>
    
      <div class="form-div ml-3" style="width: 50%">
        <label>Affiliate Url</label>
        <div class="input-div">
          <b-form-input
            :placeholder="'Affiliate Url'"
            v-model="affiliate_url"
            class="input-search"
          ></b-form-input>
        </div>
      </div>
    </div>

    <div  class=" form-div d-flex flex-row justify-content-between align-items-center align-self-start">
        <div
          class="form-group box d-flex flex-column justify-content-between align-items-center align-self-center" style="width: 50%"
        >
          <label>Fav Url</label>
           <img :src="favicon_url" :alt="$t('Affiliate trading',{ affiliate: $root.affiliate })"/>
          <div class="input-div mt-3" >
           
            <b-form-input
            :placeholder="'Fav Url'"
            v-model="favicon_url"
            class="input-search"
          ></b-form-input>
          </div>
        </div>
  
     
        <div
          class="form-group box d-flex flex-column justify-content-between align-items-center align-self-center ml-3" style="width: 50%"
        >
          <label>Header logo svg Url</label>
          <img :src="header_logo_svg"  :alt="$t('Affiliate trading',{ affiliate: $root.affiliate })"/>
          <div class="input-div mt-3" >
            
            <b-form-input
            :placeholder="'Header logo svg Url'"
            v-model="header_logo_svg"
            class="input-search "
          ></b-form-input>
          </div>
        </div>
  </div>
   <div class="form-div d-flex flex-row justify-content-between align-items-center align-self-start">
        <div
          class="form-group box d-flex flex-column justify-content-between align-items-center align-self-center" style="width: 50%"
        >
          <label>Logo svg Url</label>
          <img :src="logo_svg" :alt="$t('Affiliate trading',{ affiliate: $root.affiliate })"/>
          <div class="input-div mt-3" >
            
            <b-form-input
            :placeholder="'Logo svg Url'"
            v-model="logo_svg"
            class="input-search "
          ></b-form-input>
          </div>
        </div>
        <div
          class="form-group box d-flex flex-column justify-content-between align-items-center align-self-center ml-3" style="width: 50%"
        >
          <label>Loading icon Url</label>
          <img :src="loading_icon_url" :alt="$t('Affiliate trading',{ affiliate: $root.affiliate })"/>
          <div class="input-div mt-3" >
            
            <b-form-input
            :placeholder="'Loading icon Url'"
            v-model="loading_icon_url"
            class="input-search "
          ></b-form-input>
          </div>
        </div>
  </div>
   
  <!-- <div class="form-div row">
    
      <b-col cols="12" md="12">
        
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
          style="position: relative; overflow: scroll;"
        >
        <label>Header style Url</label>
        <div class="input-div w-100 m-3">
          <b-form-input
            :placeholder="'Header style Url'"
            v-model="header_style"
            class="input-search w-100"
          ></b-form-input>
        </div>
          <label>Header Html</label>
          <div class="input-div" style="height: 300px; width: 100%;">
            <b-textarea  id="textarea"
              v-model="header_html"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"></b-textarea>
              <div v-html="header_html" class=" m-3"></div>
          </div>
         
        </div>
      </b-col>
  </div>
  
  <div class="form-div row">
      <b-col cols="12" md="12">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
          style="position: relative; overflow: scroll;"
        >
        <label>Footer style Url</label>
        <div class="input-div w-100 m-3">
          <b-form-input
            :placeholder="'Footer style Url'"
            v-model="footer_style"
            class="input-search w-100"
          ></b-form-input>
        </div>
          <label>Footer Html</label>
          <div class="input-div" style="height: 300px; width: 100%;">
            <b-textarea  id="textarea"
              v-model="footer_html"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"></b-textarea>
              <div v-html="footer_html" class="m-3"></div>
          </div>
          
        </div>
      </b-col>
  </div> -->
    <div class="form-div row">
      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Website primary background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'primaryColor')"
              :value="websiteConfig.primaryColor.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input v-model="websiteConfig.primaryColor.colors"></b-input>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Cancel button background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'cancelColor')"
              :value="websiteConfig.cancelColor.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input v-model="websiteConfig.cancelColor.colors"></b-input>
          </div>
        </div>
      </b-col>
    
      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Marketplace background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'category_color_marketplace')"
              :value="websiteConfig.category_color_marketplace.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input
              v-model="websiteConfig.category_color_marketplace.colors"
            ></b-input>
          </div>
        </div>
      </b-col>
</div>
    <div class="form-div row">
      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Jobs background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'category_color_jobs')"
              :value="websiteConfig.category_color_jobs.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input
              v-model="websiteConfig.category_color_jobs.colors"
            ></b-input>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Realestate background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'category_color_realestate')"
              :value="websiteConfig.category_color_realestate.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input
              v-model="websiteConfig.category_color_realestate.colors"
            ></b-input>
          </div>
        </div>
      </b-col>

      <b-col cols="12" md="4">
        <div
          class="form-group color-box d-flex flex-column justify-content-center align-items-center align-self-center"
        >
          <label>Vehicles background color</label>
          <div class="input-div">
            <color-picker
              @input="updateValue($event, 'category_color_vehicles')"
              :value="websiteConfig.category_color_vehicles.colors"
              :disableAlpha="true"
              :disableFields="true"
            ></color-picker>
          </div>
          <div class="input-div mt-3">
            <b-input
              v-model="websiteConfig.category_color_vehicles.colors"
            ></b-input>
          </div>
        </div>
      </b-col>
    </div>

    <div class="form-div row">
      <b-col cols="12" md="3" class="m-2">
        <div class="form-group">
          <label>Button radius</label>
          <div class="input-div">
            <b-form-spinbutton
              id="sb-inline"
              v-model="websiteConfig.buttonRadius"
              :min="0"
              :max="100"
              step="1"
              inline
            ></b-form-spinbutton>
          </div>
        </div>
      </b-col>
    </div>
    <div class="button-div row">
      <b-col cols="12" class="text-center">
        <b-button
          @click="updateWebsiteConfig"
          id="saveProfile"
          class="btn-submit-search"
          >{{ $t("userProfile.save") }}</b-button
        >
      </b-col>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      webSiteSubtitle: null,
      title: null,
      // fontFamily: null,
      checked: true,
      websiteConfig: {
        primaryColor: {
          colors: "#CF1900",
        },
        cancelColor: {
          colors: "#e3165b",
        },
        category_color_marketplace: {
          colors: "#CF1900",
        },
        category_color_jobs: {
          colors: "#e3165b",
        },
        category_color_realestate: {
          colors: "#CF1900",
        },
        category_color_vehicles: {
          colors: "#e3165b",
        },
        buttonRadius: 60,
      },
      meta_keywords: [],
      meta_description: null,
      meta_image: null,
      favicon_url:null, 
      affiliate:null, 
      affiliate_url:null, 
      header_logo_svg:null, 
      logo_svg:null, 
      logo_url :null,
      header_style:null,
      footer_style:null,
      header_html:null,
      footer_html:null
    };
  },
  created() {
    this.getProjectConfig();
  },
  methods: {
    ...mapActions("SiteConfigController", [
      "GET_PROJECT_CONFIG",
      "SET_PROJECT_CONFIG",
    ]),
    getProjectConfig() {
      this.GET_PROJECT_CONFIG().then((result) => {
        this.title = result.home_title;
        let arrKeywords =
          result.meta_keywords && result.meta_keywords.split(",");
        this.meta_keywords = arrKeywords;
        this.meta_description = result.meta_description;
        this.meta_image = result.meta_image;
        this.favicon_url = result.favicon_url;
        this.affiliate = result.affiliate;
        this.affiliate_url = result.affiliate_url;
        this.header_logo_svg = result.header_logo_svg;
        this.logo_svg = result.logo_svg;
        this.logo_url = result.logo_url;
        this.header_html = result.header_html;
        this.footer_html = result.footer_html;
        this.header_style = result.header_style;
        this.footer_style = result.footer_style;
        if (result.home_subtitle) {
          this.webSiteSubtitle = result.home_subtitle;
        } else {
          this.checked = false;
        }
        this.$root.siteTitle_subTitle = result.home_subtitle;
        this.websiteConfig.primaryColor.colors = result.primary_color;
        this.websiteConfig.category_color_marketplace.colors =
          result.category_color_marketplace;
        this.websiteConfig.category_color_jobs.colors =
          result.category_color_jobs;
        this.websiteConfig.category_color_realestate.colors =
          result.category_color_realestate;
        this.websiteConfig.category_color_vehicles.colors =
          result.category_color_vehicles;
        document
          .querySelector(":root")
          .style.setProperty("--projectPrimaryColor", result.primary_color);
        document
          .querySelector(":root")
          .style.setProperty("--primary", result.primary_color);
        this.websiteConfig.cancelColor.colors = result.cancel_button_color;
        document
          .querySelector(":root")
          .style.setProperty(
            "--deleteButtonBgColor",
            result.cancel_button_color
          );
        this.websiteConfig.buttonRadius = parseInt(result.radio_button);
        document.documentElement.style.setProperty(
          "--borderRadius",
          result.radio_button + "px"
        );
      });
      console.log("this.websiteConfig", this.websiteConfig);
    },
    updateWebsiteConfig() {
      let obj = {
        primary_color: this.websiteConfig.primaryColor.colors,
        category_color_marketplace: this.websiteConfig.category_color_marketplace
          .colors,
        category_color_jobs: this.websiteConfig.category_color_jobs
          .colors,
        category_color_realestate: this.websiteConfig.category_color_realestate.colors,
        category_color_vehicles: this.websiteConfig.category_color_vehicles
          .colors,
        cancel_button_color: this.websiteConfig.cancelColor.colors,
        radio_button: this.websiteConfig.buttonRadius,
        home_subtitle: this.checked ? this.webSiteSubtitle : null,
        home_title: this.title,
        meta_keywords: this.meta_keywords,
        meta_description: this.meta_description,
        meta_image: this.meta_image,
        favicon_url  : this.favicon_url,
        affiliate  : this.affiliate,
        affiliate_url  : this.affiliate_url,
        header_logo_svg  : this.header_logo_svg,
        logo_svg  : this.logo_svg,
        logo_url  : this.logo_url,
        header_html  : this.header_html,
        footer_html  : this.footer_html,
        header_style  : this.header_style,
        footer_style  : this.footer_style
      };
      this.SET_PROJECT_CONFIG(obj).then((result) => {
        this.$bvToast.toast("Configs Updated!", {
          title: `Success`,
          variant: "Success",
          solid: true,
        });
        this.getProjectConfig();
        this.$root.socket.emit("website-config");
      }).catch((err)=>{
        this.$bvToast.toast(err.data.detail.message, {
          title: err.data.detail.errors[0],
          variant: "danger",
          solid: true,
        });
      });;
    },
    updateValue(ev, type) {
      this.websiteConfig[type].colors = ev.hex;
    },
    tagValidator(tag) {
      // Individual tag validator function
      return tag === tag && tag.length > 1 && tag.length < 20;
    },
  },
};
</script>

<style lang="scss">
@import "adminWebsiteConfig.scss";
</style>
